var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRecordScreen = function SvgRecordScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#393F4F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 62.7C19.7 62.7 7.2 50.3 7.2 35S19.7 7.3 35 7.3s27.8 12.4 27.8 27.8S50.3 62.7 35 62.7zm0-53.9C20.5 8.8 8.8 20.5 8.8 35S20.5 61.2 35 61.2 61.2 49.4 61.2 35 49.5 8.8 35 8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 47.2c-6.7 0-12.2-5.5-12.2-12.2S28.3 22.8 35 22.8c6.7 0 12.2 5.5 12.2 12.2S41.7 47.2 35 47.2zm0-22.9c-5.9 0-10.7 4.8-10.7 10.7S29.1 45.7 35 45.7c5.9 0 10.7-4.8 10.7-10.7S40.9 24.3 35 24.3z"
  }))));
};
export default SvgRecordScreen;